import React, { ReactElement, useState } from "react";

import { RateModal } from "~/components/BTSInProductVideoPage/Review/Modals/RateModal";
import { SuccessModal } from "~/components/BTSInProductVideoPage/Review/Modals/SuccesModal";
import { ReviewForm } from "~/components/BTSInProductVideoPage/Review/Modals/reviewTypes";
import { useAuth } from "~/hooks/auth/useAuth";
import { useAllReviewFunctions } from "~/hooks/review/useReview";
import { useAllReviewModalFunctions } from "~/hooks/review/useReviewModal";

interface Props {
  activeModal: ReviewForm;
  setActiveModal: (reviewForm: ReviewForm) => void;
}

export const ReviewFormOrchestrator = ({ activeModal, setActiveModal }: Props): ReactElement => {
  const { user } = useAuth();
  const { productInfo, onCloseModal, lastClassVideo } = useAllReviewModalFunctions();
  const { currentReview, submitReview, isLoading } = useAllReviewFunctions();

  const [productReview, setProductReview] = useState({
    reviewScore: currentReview?.reviewScore || 0,
    reviewText: currentReview?.reviewText || "",
  });

  const handleSubmit = () => {
    if (activeModal === ReviewForm.Success) {
      onCloseModal();
    } else {
      submitReview({
        productId: productInfo.id,
        userId: user?.userId,
        reviewerName: user?.firstName + " " + user?.lastName,
        reviewerProfileImageURL: user?.profilePhoto || "",
        reviewText: productReview.reviewText,
        reviewScore: productReview.reviewScore,
        source: "in-product",
        productName: productInfo.title,
        creatorName: productInfo.creatorName,
      }).then(() => {
        setActiveModal(ReviewForm.Success);
      });
    }
  };

  return (
    {
      [ReviewForm.Rate]: (
        <RateModal
          lastClassVideo={lastClassVideo}
          productReviewScore={productReview.reviewScore}
          setProductReviewScore={(score) => {
            setProductReview({ ...productReview, reviewScore: score });
          }}
          handleContinue={() => setActiveModal(ReviewForm.Review)}
        />
      ),
      [ReviewForm.Review]: (
        <RateModal
          lastClassVideo={lastClassVideo}
          isLoading={isLoading}
          productReviewScore={productReview.reviewScore}
          productReviewText={productReview.reviewText}
          setProductReviewText={(text) => setProductReview({ ...productReview, reviewText: text })}
          setProductReviewScore={(score) =>
            setProductReview({ ...productReview, reviewScore: score })
          }
          handleContinue={handleSubmit}
        />
      ),
      [ReviewForm.Success]: (
        <SuccessModal
          user={user}
          isLoading={isLoading}
          productReviewScore={productReview.reviewScore}
          productReviewText={productReview.reviewText}
          handleContinue={handleSubmit}
        />
      ),
    }?.[activeModal] || <></>
  );
};
